import * as S from "./Buttons.style";

interface ButtonProps {
  type: "submit" | "button" | "reset" | undefined;
  icon?: React.ReactNode;
  label?: string;
  children?: React.ReactNode;
  onClick?: any;
  disabled?: boolean;
  size: "xsm" | "sm" | "md" | "lg" | "full" | "icon";
  width?: string;
  color: "primary100" | "white100" | "gray100";
  layout: "solid" | "outline" | "text" | "icon";
  isFocused?: boolean;
  boxShadow?: string;
  marginTop?: string;
}

export const Button = ({
  type,
  disabled = false,
  icon,
  label,
  children,
  onClick,
  size,
  width,
  color,
  layout,
  isFocused,
  boxShadow,
  marginTop,
}: ButtonProps) => {
  return (
    <S.Buttons
      type={type}
      disabled={disabled}
      onClick={onClick}
      $width={width}
      $size={size}
      $color={color}
      $layout={layout}
      $isFocused={isFocused}
      $boxShadow={boxShadow}
      $marginTop={marginTop}
    >
      {children && children}
      {label && label}
      {icon && icon}
    </S.Buttons>
  );
};
